import { useTheme } from '@mui/material';
import { PDFViewer } from '@progress/kendo-react-pdf-viewer';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

import { pdfStyled } from './TrlPdfViewer.styles';

export const TrlPdfViewer = ({
  pdf,
  setIsScrollAtBottom,
  setIsSinglePagePdf,
  defaultZoom,
  tools,
  hasTransparentBackground,
  fileName,
}) => {
  const theme = useTheme();

  const pdfRef = useRef(null);

  const detectScrolledToBottom = (ev) => {
    const atBottom =
      Math.abs(
        ev.target.scrollHeight - ev.target.scrollTop - ev.target.clientHeight,
      ) < 1;

    if (atBottom) setIsScrollAtBottom(true);
  };

  useEffect(() => {
    const scrollableContainer = pdfRef.current?.element.querySelector(
      '.k-pdf-viewer-canvas',
    );

    scrollableContainer?.addEventListener('scroll', detectScrolledToBottom);

    return () => {
      scrollableContainer?.removeEventListener(
        'scroll',
        detectScrolledToBottom,
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pdfRef.current]);

  const onRenderToolbar = (toolbar) => {
    return (
      <toolbar.type
        {...toolbar.props}
        style={{
          ...toolbar.props.styles,
          backgroundColor: hasTransparentBackground
            ? 'transparent'
            : theme.palette.colors.primaryBackground,
          color: theme.palette.colors.onSecondaryAndDetailBackground,
          borderColor: theme.palette.colors.borderLine,
        }}
      />
    );
  };

  const onRenderContent = (content) => {
    if (content)
      return (
        <content.type
          {...content.props}
          style={{
            ...content.props.styles,
            backgroundColor: theme.palette.colors.primaryBackground,
          }}
        />
      );

    return null;
  };

  const onLoadPdfViewer = (event) => {
    if (event.target.pages.length === 1) setIsSinglePagePdf(true);
  };

  return (
    <PDFViewer
      ref={pdfRef}
      style={pdfStyled(theme, hasTransparentBackground)}
      data={pdf}
      defaultZoom={defaultZoom}
      minZoom={0.2}
      maxZoom={2}
      tools={tools}
      saveFileName={fileName}
      onRenderToolbar={onRenderToolbar}
      onRenderContent={onRenderContent}
      onLoad={onLoadPdfViewer}
    />
  );
};

TrlPdfViewer.propTypes = {
  pdf: PropTypes.string,
  setIsScrollAtBottom: PropTypes.func.isRequired,
  setIsSinglePagePdf: PropTypes.func.isRequired,
  defaultZoom: PropTypes.number.isRequired,
  tools: PropTypes.array.isRequired,
  hasTransparentBackground: PropTypes.bool,
  fileName: PropTypes.string,
};
